import { createFileRoute } from '@tanstack/react-router';
import { UserPage } from '@/modules/admin-users/user-page';

/**
 * One account, its own address.
 *
 * The legacy console opened every block in a modal — and Fields Configuration in
 * a modal above a modal above the table. That cost a deep link (an admin could
 * not send "look at this user's rights") and it cost the list: closing the modal
 * was the only way back, and the filters had to be re-applied.
 *
 * `?f=` is carried through from the list so the "back" link restores it, and
 * `tab` keeps the open block in the URL for the same reason.
 */
interface UserSearch {
  f?: string;
  tab?: string;
}

export const Route = createFileRoute('/_auth/users-rights/$userId')({
  validateSearch: (search: Record<string, unknown>): UserSearch => ({
    f: typeof search.f === 'string' ? search.f : undefined,
    tab: typeof search.tab === 'string' ? search.tab : undefined,
  }),
  component: UserPage,
});
